console.log("debug from Sweetmag: product")

window.thermosCustomizationSet = (function () {
  const SHOPIFY_DOMAIN = "thermosmalaysia.myshopify.com"
  const STOREFRONT_ACCESS_TOKEN = ""

  async function _storefrontApi(formData) {
    const headers = {
      "Content-Type": "application/json",
    }

    if (STOREFRONT_ACCESS_TOKEN) {
      headers["X-Shopify-Storefront-Access-Token"] = STOREFRONT_ACCESS_TOKEN
    }

    const response = await fetch(
      `https://${SHOPIFY_DOMAIN}/api/2025-10/graphql.json`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(formData),
      },
    )

    const json = await response.json()

    if (json.errors) {
      console.error("Storefront API Error:", json.errors)
    }

    return json
  }

  async function _ajaxApi(endpoint, formData) {
    const response = await fetch(window.Shopify.routes.root + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })

    const json = await response.json()

    if (json.errors) {
      console.error("Ajax API Error:", json.errors)
    }

    return json
  }

  function _hydrateProductVariants(data) {
    if (data == null) {
      return null
    }

    const tags = data.tags ?? []

    const mediaImages = data.media.edges
      .map(({ node }) => {
        const { url, altText } = node.image
        return {
          url,
          altText,
        }
      })
      .filter(({ altText }) => altText != null)

    const attemptGetPreviewImage = (match) => {
      if (!mediaImages.length) {
        return null
      }

      const mediaImage = mediaImages.find(({ url, altText }) => {
        return altText == match
      })

      return mediaImage?.url
    }

    const variants = data.variants.edges.map(function ({ node }) {
      const variantId = node.id.replace("gid://shopify/ProductVariant/", "")
      const title = node.title
      const image = node.image
      const available = node.availableForSale

      const frontImageUrl = attemptGetPreviewImage(node.title + " (Front)")
      const backImageUrl = attemptGetPreviewImage(node.title + " (Back)")

      const price = node.price

      return {
        variantId,
        title,
        image,
        available,
        frontImageUrl,
        backImageUrl,
        price,
        tags,
      }
    })

    return variants
  }

  function _refreshCart() {
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"))
  }

  function _errorMessageBag(message, errors = null) {
    return {
      message,
      errors,
    }
  }

  function _hash32(string) {
    let hash = 5381

    for (let i = 0; i < string.length; i++) {
      const code = string.charCodeAt(i)
      hash = ((hash << 5) + hash) ^ code
    }

    return hash >>> 0
  }

  async function getProductVariantsById(id) {
    const query = `
			query getProductById($id: ID!) {
				product(id: $id) {
					id
					title
					tags
					media(first: 250) {
						edges {
							node {
								... on MediaImage {
									id
									image {
										url
										altText
									}
								}
							}
						}
					}
					variants(first: 250) {
						edges {
							node {
								id
								title
								availableForSale
								image {
									url
								}
                price {
                  amount
                  currencyCode
                }
							}
						}
					}
				}
			}
		`

    const gid = `gid://shopify/Product/${id}`

    const json = await _storefrontApi({
      query,
      variables: {
        id: gid,
      },
    })

    return _hydrateProductVariants(json.data?.product)
  }

  async function addBuiltSetToCart(builtSet) {
    const {
      bodyVariantId,
      bottomCoverVariantId,
      stopperVariantId,
      iconVariantId,
      engravingFont,
      engravingText,
      textOnlyVariantId,
      bodyVolume,
      giftBoxVariantId,
    } = builtSet
    const customizationSetUid = _hash32(JSON.stringify(builtSet))

    /** validator: https://github.com/mikeerickson/validatorjs */
    const validation = new Validator(
      builtSet,
      {
        bodyVariantId: "required",
        stopperVariantId: "required",
        engravingFont: "required_with:engravingText",
        engravingText: "required_with:engravingFont",
      },
      {
        required: ":attribute option is required.",
      },
    )

    validation.setAttributeNames({
      bodyVariantId: "Body",
      stopperVariantId: "Stopper",
      engravingFont: "Engraving font",
      engravingText: "Engraving text",
    })

    const errors = validation.fails() ? validation.errors.errors : null

    if (errors != null) {
      return _errorMessageBag(
        "Kindly ensure all required selections are made in order to continue.",
        errors,
      )
    }

    const getBodyPartName = () => {
      if (bodyVolume == 250) {
        return "Body 250ml"
      }
      if (bodyVolume == 500) {
        return "Body 500ml"
      }
      return "Body"
    }

    const formData = {
      items: [
        ...(giftBoxVariantId != null
          ? [
              {
                id: giftBoxVariantId,
                quantity: 1,
                properties: {
                  "Customization Set ID": customizationSetUid,
                  "Customization Part": "Gift Box",
                },
              },
            ]
          : []),
        ...(iconVariantId != null
          ? [
              {
                id: iconVariantId,
                quantity: 1,
                properties: {
                  "Customization Set ID": customizationSetUid,
                  "Customization Part": "Icon",
                },
              },
            ]
          : []),
        ...(textOnlyVariantId != null
          ? [
              {
                id: textOnlyVariantId,
                quantity: 1,
                properties: {
                  "Customization Set ID": customizationSetUid,
                  "Customization Part": "Engraving text only",
                },
              },
            ]
          : []),
        ...(bottomCoverVariantId != null
          ? [
              {
                id: bottomCoverVariantId,
                quantity: 1,
                properties: {
                  "Customization Set ID": customizationSetUid,
                  "Customization Part": "Bottom cover",
                },
              },
            ]
          : []),
        {
          id: bodyVariantId,
          quantity: 1,
          properties: {
            "Customization Set ID": customizationSetUid,
            "Customization Part": getBodyPartName(),
            ...(engravingText != null
              ? {
                  Font: engravingFont,
                  Text: engravingText,
                }
              : {}),
          },
        },
        {
          id: stopperVariantId,
          quantity: 1,
          properties: {
            "Customization Set ID": customizationSetUid,
            "Customization Part": "Stopper",
          },
        },
      ],
    }

    const json = await _ajaxApi("cart/add.js", formData)

    if (json.items?.length > 0) {
      _refreshCart()
      return null
    }

    if (json.message != null) {
      return _errorMessageBag(json.message)
    }

    console.error(json)

    return _errorMessageBag(
      "An unexpected error occurred. Please contact support for further assistance.",
    )
  }

  return {
    getProductVariantsById,
    addBuiltSetToCart,
  }
})()
